import LogRocket from 'logrocket'
import { environment } from '../environment'

if (environment.REACT_APP_LOGROCKET_APP_ID && !window.Cypress) {
  LogRocket.init(environment.REACT_APP_LOGROCKET_APP_ID)
}
